import {
  ListingRecommendationItem,
  ListingRecommendationRejectionReason,
} from 'common/api-types/recommendations';

export function getRecommendationItems(_ids: string[], items: ListingRecommendationItem[]) {
  const ids = new Set(_ids);
  return items.filter(({ id }) => ids.has(id)).map(({ id, version }) => ({ id, version }));
}

export const reasons: ListingRecommendationRejectionReason[] = ['LEGAL_BLOCKER', 'OTHER'];
